import { Box, Toolbar, Grid, Typography, Card, CardContent, CardMedia, Button } from '@material-ui/core'
import Fab from '@material-ui/core/Fab'
import { makeStyles } from '@material-ui/core/styles'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import React from 'react'

import { ScrollTop } from '../../components/BackToTop'
import Footer from '../../components/Footer/Footer.js'
import SectionContainer from '../../components/SectionContainer'
import TypoOutlined from '../../components/Typography/TypoOutlined'
import TypoTitle from '../../components/Typography/TypoTitle'
import industries from '../../data/industries'
import { useHistory } from 'react-router-dom'

import '../../scss/styles.scss'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: 'white'
  },
  headerSection: {
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(8)
    },
    [theme.breakpoints.between('xs', 'md')]: {
      marginTop: theme.spacing(6)
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(4)
    }
  },
  heroTitle: {
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(8)
    },
    [theme.breakpoints.between('xs', 'md')]: {
      marginTop: theme.spacing(1)
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(1)
    }
  },
  industryCard: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
      transform: 'scale(1.03)',
      boxShadow: theme.shadows[8]
    }
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9 aspect ratio
    backgroundSize: 'cover'
  },
  cardContent: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  capabilityList: {
    paddingLeft: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  viewMoreButton: {
    backgroundColor: "#3d3d3d",
    color: 'white',
    marginTop: 'auto',
    alignSelf: 'flex-start',
    '&:hover': {
      backgroundColor: "#000000"
    }
  },
  strongWord: {
    fontSize: '11vw',
    [theme.breakpoints.down('sm')]: {
      fontSize: '5vw'
    }
  }
}))

export default function Industries(props) {
  const classes = useStyles()
  const history = useHistory()

  const handleViewMore = (industrySlug) => {
    history.push(`/industries/${industrySlug}`)
  }

  return (
    <div className={classes.root}>
      <Toolbar id="back-to-top-anchor" style={{ backgroundColor: 'black' }} />
      
      <SectionContainer backgroundColor="black">
        <Box className={classes.heroTitle}>
          <Box marginTop={4}>
            <TypoTitle text={'Our Industries'} color={'white'} fontSize={'4vw'} />
          </Box>
          <Box>
            <TypoOutlined text={'EXPERTISE.'} color={'black'} />
          </Box>
          <Typography variant="h6" style={{ color: 'white', marginTop: 20, marginBottom: 40 }}>
            We deliver innovative solutions across a wide range of industries
          </Typography>
        </Box>
      </SectionContainer>

      <SectionContainer backgroundColor="white">
        <Grid container spacing={4}>
          {industries.map((industry) => (
            <Grid item key={industry.id} xs={12} sm={6} md={4}>
              <Card className={classes.industryCard}>
                {/* <CardMedia
                  className={classes.cardMedia}
                  image={industry.img}
                  title={industry.name}
                /> */}
                <CardContent className={classes.cardContent}>
                  <Typography gutterBottom variant="h5" component="h2">
                    {industry.name}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" paragraph>
                    {industry.mainDesc}
                  </Typography>
                  
                  <Typography variant="subtitle1" component="h3" style={{ marginTop: 16, marginBottom: 8 }}>
                    Key Capabilities:
                  </Typography>
                  <ul className={classes.capabilityList}>
                    {industry.capabilities.slice(0, 3).map((capability, index) => (
                      <li key={index}>
                        <Typography variant="body2">{capability}</Typography>
                      </li>
                    ))}
                    {industry.capabilities.length > 3 && (
                      <li>
                        <Typography variant="body2">And more...</Typography>
                      </li>
                    )}
                  </ul>
                  
                  <Button 
                    variant="contained" 
                    className={classes.viewMoreButton}
                    onClick={() => handleViewMore(industry.slug)}
                  >
                    View Details
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </SectionContainer>

      <Box marginTop={8}>
        <Footer />
      </Box>

      <ScrollTop {...props}>
        <Fab color="secondary" size="small" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
    </div>
  )
}